import React from 'react';
import classnames from 'classnames';
import StyledLabel from '../styled-label';
import InfoModal from './info-modal';
import VPCItems from './items';
import { PT_ITEMS, PT_INFOMODAL } from './proptypes';

const namespace = 'ui-pdp-vehicle-physical-condition';

const VehiclePhysicalCondition = ({ title, subtitle, items, info_modal: infoModal }) => (
  <div className={classnames(namespace)}>
    <div className={classnames(`${namespace}__header`)}>
      <StyledLabel as="h2" className={`${namespace}__title`} {...title} />
      <StyledLabel as="span" className={`${namespace}__subtitle`} {...subtitle} />
    </div>
    <VPCItems namespace={namespace} items={items} />
    {infoModal && <InfoModal {...infoModal} />}
  </div>
);

VehiclePhysicalCondition.propTypes = {
  title: StyledLabel.propTypes,
  subtitle: StyledLabel.propTypes,
  items: PT_ITEMS,
  info_modal: PT_INFOMODAL,
};

VehiclePhysicalCondition.displayName = 'VehiclePhysicalCondition';

export default React.memo(VehiclePhysicalCondition);
